<template>
  <div class="answer-area">
    <div class="creation-wrap" v-show="isOperateQuestion">
      <div id="iframeWrap" class="editor"></div>
      <div v-show="loading" class="work-loading">
        作品加载中...
      </div>
    </div>
    <div v-show="currentAnswer.typeId === 20" class="textarea-wrap">
      <p class="name">考生答案：</p>
      <p class="answer">{{ currentAnswer.answer }}</p>
    </div>
    <div v-show="currentAnswer.questionType === 1" class="textarea-wrap download-wrap">
      <p class="name">考生答案：</p>
      <div class="answer">
        <div class="has-answer" v-if="currentAnswer.answer">
          <icon-py-file class="icon icon-py-file"></icon-py-file>
          <p class="filename">{{ filename }}</p>
          <button class="download-btn" @click="downloadFile">
            <icon-download class="icon icon-download"></icon-download>考生答案下载
          </button>
        </div>
        <div v-else class="no-answer">
          <icon-no-answer class="icon-no-answer"></icon-no-answer>
          <p class="text">考生答案为空</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue'
import IconDownload from '@/assets/svg/judge/download.svg'
import IconPyFile from '@/assets/svg/judge/py-file.svg'
import IconNoAnswer from '@/assets/svg/judge/icon-noanswer.svg'
import { downloadData } from '@/utils'
import { get } from '@/utils/ajax'

// 操作题类型集合 0-kitten 2-python 3-scratch 4-nemo 5-explore 6-c++ 7-python_oj
const operateQuestionTypes = [0, 2, 3, 4, 5, 6, 7]

export default {
  components: {
    IconDownload,
    IconPyFile,
    IconNoAnswer
  },
  props: {
    currentQuestion: Object,
    currentAnswer: Object
  },
  data() {
    return {
      loading: false,

      editorUrl: '',
      filename: '',
      editorLink: '',
      blankBcm: 'https://public-static-edu.codemao.cn/eduexam/blank.bcm',
      uploadUrl: '',

      operateIds: ['kitten', '', 'python', 'scratch', 'nemo', 'explore', 'cplusplus', 'python_oj'], // 工具类型，ID作为唯一键
      operateIniteds: [false, false, false, false, false, false, false, false] // 工具初始化状态，questionType 的值为索引
    }
  },
  computed: {
    // 是否是操作题
    isOperateQuestion() {
      return operateQuestionTypes.includes(this.currentQuestion.questionType)
    }
  },
  watch: {
    async currentAnswer(val) {
      if (val && val.id) {
        this.initIframe()
      }
    }
  },
  methods: {
    // 初始化操作题
    initIframe() {
      const { questionType } = this.currentQuestion
      // 当前题目是操作题
      if (this.isOperateQuestion) {
        this.createIframe(questionType)
        this.hideIframe(questionType)
      }
    },
    // 创建操作题dom节点
    createIframe(questionType) {
      const id = this.operateIds[questionType]
      let url = ''
      switch (questionType) {
        case 0: // kitten
          url = `${CONFIG.ide}?in_edu_lesson=true`
          break
        case 2: // python
          url = CONFIG.python
          break
        case 3: // scratch
          url = CONFIG.scratch
          break
        case 5: // 闯关
          url = this.currentQuestion.uploadUrl
          break
        case 6: // c++
          url = CONFIG.cplusplus
          break
        case 7: // python_oj
          url = CONFIG.python_oj
          break
      }
      const iframeWrap = document.querySelector('#iframeWrap')
      const hasIframe = iframeWrap.querySelector(`#${id}`) // 是否已存在该题型的iframe
      if (hasIframe) {
        // 直接加载当前题目内容
        this.loadWork()
      } else {
        this.loading = true
        // 创建新的Iframe
        // 创建构造器
        const Profile = Vue.extend({
          template:
            '<iframe :src="url" :id="id" width="100%" height="100%" class="if-common" allow="microphone;camera;midi;encrypted-media;"></iframe>',
          data: function () {
            return {
              url: url,
              id: id
            }
          }
        })
        const a = new Profile().$mount().$el
        // 创建 Profile 实例，并挂载
        iframeWrap.appendChild(a)
      }
    },
    // 隐藏iframe
    hideIframe(type) {
      const id = this.operateIds[type]
      const iframeWrap = document.querySelectorAll('.if-common')
      iframeWrap.forEach((item) => {
        item.style.display = item.id === id ? 'block' : 'none'
      })
    },
    async loadWork() {
      this.loading = true
      const { questionType } = this.currentQuestion
      const answer = this.currentAnswer.answer

      // 是否初始化完成
      const inited = this.operateIniteds[questionType]
      if (!inited) {
        return
      }

      const iframeId = this.operateIds[questionType]
      const iframe = document.getElementById(iframeId)
      if (!iframe) {
        return
      }
      const iframeWindow = iframe.contentWindow
      switch (questionType) {
        case 0: // kitten
          let bcmUrl = this.currentQuestion.uploadUrl
          if (answer) {
            const { bcm_url } = await get(`/edu/exams/works/kitten?code=${answer}`)
            bcmUrl = bcm_url
          }
          iframeWindow.postMessage({ type: 'load_bcm', content: bcmUrl }, CONFIG.ide)
          break
        case 3: // scratch
          let sb3Url = this.currentQuestion.uploadUrl
          if (answer) {
            sb3Url = answer
          }
          iframeWindow.postMessage({ type: 'load_sb3', content: sb3Url }, CONFIG.scratch)
          break
        case 4: // nemo
          iframe.src = `${window.CONFIG.tanyuepigai}/edu?workUrl=${encodeURIComponent(answer || this.uploadUrl)}`
          this.loading = false
          break
        case 5: // 闯关题
          iframe.src = this.currentQuestion.uploadUrl
          break
        case 2: // python
        case 6: // c++
        case 7: // python_oj
          if (questionType === 2) { // python
            iframeWindow.postMessage({ msg: 'set_python_code', code: answer }, CONFIG.python)
          } else { // c++ 或 python_oj
            iframeWindow.postMessage({
              type: 'WORK_OPEN',
              payload: {
                work: {
                  work_id: 0,
                  name: '新的作品',
                  extension: questionType === 6 ? 'cpp' : 'py',
                  content: answer,
                  version: 0
                }
              }
            }, questionType === 6 ? CONFIG.cplusplus : CONFIG.python_oj)
          }
          this.loading = false
          break
      }
    },
    // 操作题接收 postMessage 消息
    iframeMessage(e) {
      const questionType = this.currentQuestion.questionType
      const message = e.data
      switch (message.type) {
        case 'kitten_loaded': // kitten工具初始化完成
          this.operateIniteds[0] = true
          this.initKitten()
          if (questionType === 0) {
            this.loadWork()
          }
          break
        case 'scratch_loaded': // scratch工具初始化完成
          this.operateIniteds[3] = true
          if (questionType === 3) {
            this.loadWork()
          }
          break
        case 'exam_load_bcm_end': // 加载bcm的结果
          this.loading = false
          if (message.content.content.status === 'error') {
            this.$message.error('加载作品失败')
          }
          break
        case 'exam_load_sb3_end': // 加载sb3的结果
          this.loading = false
          if (message.content.content.status === 'error') {
            this.$message.error('加载作品失败')
          }
          break
        case 'IFRAME_READY': // c++、python_oj工具初始化完成
          this.operateIniteds[message.payload.page === 'cpp_oj' ? 6 : 7] = true
          this.initTart(message.payload.page)
          if ([6, 7].includes(questionType)) {
            this.loadWork()
          }
          break
      }
      switch (message.msg) {
        case 'wood_is_ready': // python初始化完成
          this.operateIniteds[2] = true
          this.initPython()
          if (questionType === 2) {
            this.loadWork()
          }
          break
        case 'ExplorerInit':
          this.operateIniteds[5] = true
          this.loading = false
          break
      }
    },
    // 初始化Tart工具 type= 'py_oj' | 'cpp_oj'
    initTart(type) {
      let tart = null
      let domain = '*'
      let exportName = ''
      switch (type) {
        case 'py_oj':
          tart = document.getElementById('python_oj')
          domain = CONFIG.python_oj
          exportName = 'exportAsPythonFile'
          break
        case 'cpp_oj':
          tart = document.getElementById('cplusplus')
          domain = CONFIG.cplusplus
          exportName = 'exportAsCppFile'
          break
        default:
          throw new Error('未知编辑器')
      }

      if (!tart) return
      const tartWindow = tart.contentWindow

      tartWindow.postMessage(
        {
          type: 'FEATURE_SET_CONFIG',
          payload: {
            headerDisabled: false, // 默认展示头部栏，true 则隐藏
            headerLogoDisabled: true, // 默认展示头部栏中的Logo，true 则隐藏
            headerFileMenuDisabled: false, // 默认展示头部栏中的文件菜单，true 则隐藏
            headerFileMenuItems: [
              // 'createProject',
              // 'openProjectManager',
              // 'workSaveAs',
              // 'divider',
              // 'openLocalFile',
              exportName
              // 'divider',
              // 'importMiaoLink',
              // 'exportAsMiaoLink',
            ], // 默认展示所有头部栏文件菜单选项，[] 则隐藏所有
            userAvatarDisabled: true, // 默认展示用户头像，true 则隐藏
            workSaveButtonDisabled: true, // 默认展示作品保存按钮，true 则隐藏
            workNameInputDisabled: true, // 默认展示作品名称输入框，true 则隐藏
            disabledRegExp: true // 默认隐藏正则配置，false 则展示
          }
        },
        domain
      )
    },
    // 初始化kitten配置项
    initKitten() {
      const kitten = document.getElementById('kitten')
      if (!kitten) return
      const kittenWindow = kitten.contentWindow
      kittenWindow.postMessage(
        {
          type: 'kitten_set_ui',
          content: {
            header: {
              file: true, // 展示文件按钮
              export_file: true, // 展示保存作品到本地
              setting: true, // 展示设置按钮
              language: true, // 展示语言切换
              save: false // 隐藏保存按钮
            }
          }
        },
        CONFIG.ide
      )
    },
    initPython() {
      const python = document.getElementById('python')
      if (!python) return
      const pythonWindow = python.contentWindow
      // 设为代码模式
      pythonWindow.postMessage({ msg: 'set_default_mode', mode: 'code' }, CONFIG.python)
      // 隐藏切换积木模式按钮
      pythonWindow.postMessage({ msg: 'set_mode_btn_display', mode: 'false' }, CONFIG.python)
      // 隐藏自带的缩放按钮
      pythonWindow.postMessage({ msg: 'set_fullscreen_btn_display', is_display: false }, CONFIG.python)
      // 隐藏帮助按钮
      pythonWindow.postMessage({ msg: 'set_help_btn_display', is_display: false }, CONFIG.python)
      // 打开海龟绘图
      pythonWindow.postMessage({ msg: 'set_turtle_canvas_display', is_display: true }, CONFIG.python)
    },
    downloadFile() {
      downloadData(this.currentAnswer.answer)
    }
  },
  mounted() {
    window.addEventListener('message', this.iframeMessage)
  },
  destroyed() {
    window.removeEventListener('message', this.iframeMessage)
  }
}
</script>

<style lang="scss" scoped>
.answer-area {
  flex: 1;
  height: 100%;
}
.creation-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  .work-loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 24px;
    font-weight: 300;
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.editor {
  width: 100%;
  height: 100%;
  display: inline-block;
}

.textarea-wrap {
  width: 100%;
  padding: 0 60px;

  .name {
    margin-top: 30px;
    font-size: 18px;
    color: #333;
  }

  .answer {
    background: rgba(56, 126, 253, 0.03);
    border-radius: 8px;
    border: 1px solid $themeColor;
    height: 200px;
    padding: 10px 25px;
    margin-top: 20px;
    font-size: 20px;
    font-weight: 500;
    color: #333;
  }
}

.download-wrap {
  .icon {
    display: inline-block;
  }

  .answer {
    display: flex;
    padding-top: 45px;
  }

  .filename {
    max-width: 256px;
    @include text-ellipsis(1);
    margin: 5px 20px 0 20px;
    font-size: 16px;
  }

  .download-btn {
    width: 160px;
    height: 42px;
    border-radius: 4px;
    border: 1px solid #397EFD;
    background: rgba(56, 126, 253, 0.03);
    color: $themeColor;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      background: $themeColor;
      color: #fff;

      .icon-download {
        fill: #fff;
      }
    }
  }

  .icon-download {
    fill: $themeColor;
    margin-right: 6px;
  }

  .no-answer {
    margin: -25px auto 0 auto;
  }

  .icon-no-answer {
    display: inline-block;
  }

  .text {
    font-size: 16px;
    text-align: center;
  }

  .has-answer {
    display: flex;
  }
}
</style>
